let resumeData = {
    "imagebaseurl":"https://manish.dev/",
    "name": "Manish Shrestha",
    "role": "Software Development Engineer in Test (SDET)",
    "linkedinId":"Your LinkedIn Id",
    "skypeid": "Your skypeid",
    "roleDescription": "I enjoy experimenting with different frontend and backend development aspects, learning about new technologies, and playing video games in my leisure time.",
    "socialLinks":[
        {
          "name":"linkedin",
          "url":"https://www.linkedin.com/in/shrestha-manish/",
          "className":"fa fa-linkedin"
        },
        {
          "name":"github",
          "url":"http://github.com/manishshres",
          "className":"fa fa-github"
        },
        {
          "name":"email",
          "url":"mailto:manish.shres@outlook.com",
          "className":"fa fa-envelope"
        }
      ],
    "aboutme":"I am a software engineer and graduate student at Penn State.  I am originally from the Kathmandu, Nepal. I love to write code and enjoy playing the guitar on spare time. I'm always looking for opportunities to grow my skillset.",
    "address":"Philadelphia, PA",
    "website":"https://manish.dev",
    "education":[
      {
        "UniversityName":"Penn State University",
        "specialization":"Masters in Software Engineering",
        "MonthOfPassing":"Aug",
        "YearOfPassing":"2023",
      },
      {
        "UniversityName":"West Chester University",
        "specialization":"Bachelors in Computer Science",
        "MonthOfPassing":"May",
        "YearOfPassing":"2019",
      }
    ],
    "work":[
      {
        "CompanyName":"Vertex",
        "specialization":"Test Engineer II",
        "MonthOfLeaving":"",
        "YearOfLeaving":"Present",
      },
      {
        "CompanyName":"Entech",
        "specialization":"QA Consultant",
        "MonthOfLeaving":"Dec",
        "YearOfLeaving":"2020",
      },
      {
        "CompanyName":"URBN",
        "specialization":"Overnight SysAdmin",
        "MonthOfLeaving":"Dec",
        "YearOfLeaving":"2019",
      }
    ],
    "skillsDescription":"Your skills here",
    "skills":[
      {
        "skillname":"HTML5"
      },
      {
        "skillname":"CSS"
      },
      {
        "skillname":"Reactjs"
      }
    ],
    "portfolio":[
      {
        "name":"project1",
        "description":"mobileapp",
        "imgurl":"images/portfolio/phone.jpg"
      },
      {
        "name":"project2",
        "description":"mobileapp",
        "imgurl":"images/portfolio/project.jpg"
      },
      {
        "name":"project3",
        "description":"mobileapp",  
        "imgurl":"images/portfolio/project2.png"
      },
      {
        "name":"project4",
        "description":"mobileapp",
        "imgurl":"images/portfolio/phone.jpg"
      }
    ],
    "testimonials":[
      {
        "description":"This is a sample testimonial",
        "name":"Some technical guy"
      },
      {
        "description":"This is a sample testimonial",
        "name":"Some technical guy"
      }
    ]
  }
  
  export default resumeData